/**
 * @file
 * @fileOverview This file contains the CustomTextInput class for the Phaser scene.
 * @version 1.0.0
 * @author Parker Eli Bidigare
 * @date 2024-05-26
 */

import "phaser"
class CustomTextInput extends Phaser.GameObjects.Container {
  constructor(scene, x, y, width, height, initialText = '') {
    super(scene, x, y);

    this.width = width;
    this.height = height;
    this.textValue = initialText;

    // Draw background
    this.background = scene.add.graphics();
    this.background.fillStyle(0xffffff, 1); // white background
    this.background.fillRect(0, 0, width, height);
    this.add(this.background);

    // Add text
    this.text = scene.add.text(5, 5, initialText, {
      fontSize: '16px',
      fill: '#000',
    });
    this.add(this.text);

    // Make container interactive
    this.setSize(width, height);
    this.setInteractive(
      new Phaser.Geom.Rectangle(0, 0, width, height),
      Phaser.Geom.Rectangle.Contains
    );
    scene.input.setDraggable(this);

    // Add to scene
    scene.add.existing(this);

    // Handle focus and input
    this.setFocus(false);
    this.createInputListeners();
  }

  createInputListeners() {
    this.on('pointerdown', () => {
      this.setFocus(true);
    });

    this.scene.input.keyboard.on('keydown', (event) => {
      if (this.hasFocus) {
        if (event.key === 'Backspace') {
          this.textValue = this.textValue.slice(0, -1);
        } else if (event.key.length === 1) {
          // handle only character keys
          this.textValue += event.key;
        }
        this.text.setText(this.textValue);
      }
    });

    this.scene.input.on('pointerdown', (pointer, gameObjects) => {
      if (!gameObjects.includes(this)) {
        this.setFocus(false);
      }
    });
  }

  setFocus(focus) {
    this.hasFocus = focus;
    if (focus) {
      this.background.lineStyle(2, 0x0000ff, 1); // blue border for focus
    } else {
      this.background.lineStyle(2, 0x000000, 1); // black border for blur
    }
    this.background.strokeRect(0, 0, this.width, this.height);
  }

  getTextValue() {
    return this.textValue;
  }

  clearText() {
    this.textValue = '';
    this.text.setText('');
  }
}

export default CustomTextInput;
